module.exports = __webpack_public_path__ + "static/media/landing-image@2x.c5204250.png";